import { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import FbfCreateShipmentPage from "@faire/prototype-playground/workspace/kv/fbf-create-shipment";

const AddProductsFullscreen = lazy(
  () => import("../../pages/CreateShipmentPage/AddProductsFullscreen")
);
const AreItemsFragileFullscreen = lazy(
  () => import("../../pages/CreateShipmentPage/AreItemsFragileFullscreen")
);
const BillingPage = lazy(() => import("../../pages/BillingPage"));
const ChooseProductsFullscreen = lazy(
  () => import("../../pages/CreateShipmentPage/ChooseProductsFullscreen")
);
const CreateShipmentPage = lazy(
  () => import("../../pages/CreateShipmentPage/index")
);
const FBFPerformancePage = lazy(() => import("../../pages/FBFPerformancePage"));
const FBFSupportMessengerPage = lazy(
  () => import("../../pages/FBFSupportMessengerPage")
);
const FBFSurfaceTestPage = lazy(
  () => import("../../pages/FBFSurfaceTestPage/index")
);
const FulfillmentFunnelPage = lazy(
  () => import("../../pages/FulfillmentFunnelPage")
);
const ProductSetupPage = lazy(() => import("../../pages/ProductSetupPage"));
const SendInventoryFlowPage = lazy(
  () => import("../../pages/SendInventoryFlowPage")
);
const ShipmentDraftsPage = lazy(() => import("../../pages/ShipmentDraftsPage"));
const OnTheGoAppPage = lazy(() => import("../../pages/OnTheGoAppPage"));
const ShipmentsPage = lazy(
  () => import("../../pages/CreateShipmentPage/ShipmentsPage")
);
const Step3Fullscreen = lazy(
  () => import("../../pages/CreateShipmentPage/Step3Fullscreen")
);
const Step4Fullscreen = lazy(
  () => import("../../pages/CreateShipmentPage/Step4Fullscreen")
);
const AddProductsFullscreenV2 = lazy(
  () => import("../../pages/CreateShipmentPage/AddProductsFullscreenV2")
);
const CatalogDashboardFBFShell = lazy(() =>
  import("../../pages/faire/CatalogDashboardFBF/CatalogDashboardFBFShell").then(
    (m) => ({ default: m.CatalogDashboardFBFShell })
  )
);
const PrepareShipmentFullscreen = lazy(
  () => import("../../pages/CreateShipmentPage/PrepareShipmentFullscreen")
);
const PrepareShipmentFullscreenV2 = lazy(
  () => import("../../pages/CreateShipmentPage/PrepareShipmentFullscreenV2")
);

export function KatherineVidalRoutes() {
  return (
    <Switch>
      <Route
        path="/kv/faire/catalog-dashboard-fbf"
        render={() => <CatalogDashboardFBFShell key="catalog-dashboard-fbf" />}
      />
      <Route path="/kv/fbf-create-shipment" component={FbfCreateShipmentPage} />

      <Route path="/kv/fbf-performance" component={FBFPerformancePage} />
      <Route
        path="/kv/fbf-support-messenger"
        component={FBFSupportMessengerPage}
      />
      <Route
        path="/kv/fulfillment-bulk-editor"
        component={FBFSurfaceTestPage}
      />
      <Route path="/kv/fulfillment-funnel" component={FulfillmentFunnelPage} />
      <Route
        path="/kv/send-inventory-flow/add-products"
        component={AddProductsFullscreen}
      />
      <Route
        path="/kv/send-inventory-flow/create/choose-products"
        component={ChooseProductsFullscreen}
      />
      <Route
        path="/kv/send-inventory-flow/create/fragile"
        component={AreItemsFragileFullscreen}
      />
      <Route
        path="/kv/send-inventory-flow/create/step-3"
        component={Step3Fullscreen}
      />
      <Route
        path="/kv/send-inventory-flow/create/step-4"
        component={Step4Fullscreen}
      />
      <Route
        exact
        path="/kv/send-inventory-flow/create"
        component={CreateShipmentPage}
      />
      <Route
        path="/kv/send-inventory-flow/drafts"
        component={ShipmentDraftsPage}
      />
      <Route path="/kv/send-inventory-flow/billing" component={BillingPage} />
      <Route path="/kv/send-inventory-flow" component={SendInventoryFlowPage} />
      <Route path="/kv/product-setup" component={ProductSetupPage} />
      <Route
        path="/kv/pack-shipment/v2/prepare"
        render={() => (
          <PrepareShipmentFullscreenV2
            closeTo="/pack-shipment"
            title="Create shipment"
            continueTo="/pack-shipment"
          />
        )}
      />
      <Route
        path="/kv/pack-shipment/v2/add-products"
        render={() => (
          <AddProductsFullscreenV2
            closeTo="/pack-shipment"
            title="Create shipment"
            continueTo="/pack-shipment/v2/prepare"
          />
        )}
      />
      <Route
        path="/kv/pack-shipment/v1/prepare"
        render={() => (
          <PrepareShipmentFullscreen
            closeTo="/pack-shipment"
            title="Create shipment"
            continueTo="/pack-shipment"
          />
        )}
      />
      <Route
        path="/kv/pack-shipment/v1/add-products"
        render={() => (
          <AddProductsFullscreen
            closeTo="/pack-shipment"
            title="Create shipment"
            continueTo="/pack-shipment/v1/prepare"
          />
        )}
      />
      <Route
        path="/kv/pack-shipment/prepare"
        render={() => (
          <PrepareShipmentFullscreen
            closeTo="/pack-shipment"
            title="Create shipment"
            continueTo="/pack-shipment"
          />
        )}
      />
      <Route
        path="/kv/pack-shipment/add-products"
        render={() => (
          <AddProductsFullscreen
            closeTo="/pack-shipment"
            title="Create shipment"
            continueTo="/pack-shipment/v1/prepare"
          />
        )}
      />
      <Route path="/kv/on-the-go-app" component={OnTheGoAppPage} />
      <Route exact path="/kv/pack-shipment" component={ShipmentsPage} />
    </Switch>
  );
}

export const slug = "kv";
